import { Link } from "react-router-dom";
import { GitCompare, X } from "lucide-react";
import { useCompare } from "../context/CompareContext";

export function CompareBar() {
  const { items, remove, clear } = useCompare();
  if (items.length === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-40 w-[calc(100%-2rem)] max-w-3xl -translate-x-1/2" data-testid="compare-bar">
      <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white/95 p-3 shadow-2xl backdrop-blur">
        <div className="flex items-center gap-2 pl-1 text-[#0B1B3D]">
          <GitCompare className="h-5 w-5 text-[#10B981]" />
          <span className="hidden text-sm font-semibold sm:inline">Compare</span>
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#ECFDF5] text-xs font-bold text-[#059669]">
            {items.length}
          </span>
        </div>
        <div className="flex flex-1 gap-2 overflow-x-auto scrollbar-hide">
          {items.map((p) => (
            <span key={p.id} className="flex shrink-0 items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700">
              {p.name}
              <button onClick={() => remove(p.id)} className="text-slate-400 hover:text-red-500">
                <X className="h-3.5 w-3.5" />
              </button>
            </span>
          ))}
        </div>
        <button onClick={clear} className="hidden text-xs font-medium text-slate-400 hover:text-red-500 sm:inline">Clear</button>
        <Link to="/compare" data-testid="compare-bar-view-btn"
          className="shrink-0 rounded-xl bg-[#10B981] px-4 py-2 text-sm font-bold text-white hover:bg-[#059669]">
          Compare
        </Link>
      </div>
    </div>
  );
}
